export const POOL_REFRESH_RATE = 5 * 60 * 1000;
export const SITE_REFRESH_RATE = 30 * 60 * 1000;
export const CHANCE_TO_REPLACE = 0.6;
export const FOCUS_REFRESH_RATE = 10 * 1000;
export const API_HOSTNAME = "https://76gmlikfnb.execute-api.us-west-2.amazonaws.com/Production";



// WEBPACK FOOTER //
// ./config/production/index.ts